export const view = {
    methods: {
        
    }
}